import React, { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FormDataType } from 'contexts/FormProvider';
import { useContentContext } from '@qbe/dfc-content';
import { FormCard } from '@qbe/ads-blocks-forms';

import { RadioSelectableCard } from '@qbe/ads-core';
import { breachTypes } from 'utils/constants';
import { useContentComplaintPartners } from 'utils/content';

interface Props {
  form: UseFormReturn<FormDataType>;
}

const BreachType: FC<Props> = (props) => {
  const { form } = props;
  const { getTextContent } = useContentComplaintPartners({ context: useContentContext() });

  const { control } = form;

  return (
    <FormCard variant="sectionTitle" title={getTextContent('breach.tell.us.more.heading')}>
      <Controller
        name="breachType"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <RadioSelectableCard
            {...field}
            // todo: when this is fixed can remove this workaround
            // https://qbe-appservices.atlassian.net/browse/AD1-581
            {...({
              sx: {
                '.MuiFormControlLabel-root': {
                  alignItems: 'start',
                },
                '.MuiRadio-root': {
                  marginTop: '2.5px',
                },
              },
            } as any)}
            required
            title={getTextContent('breach.tell.us.more.breachType')}
            radioList={breachTypes.map(({ text, value, infoPopUp }) => {
              return {
                label: text,
                value,
                id: value,
                subText: infoPopUp.content as string,
                labelProps: {
                  ['data-testid']: 'wtf',
                },
              };
            })}
            data-track="breachType"
            data-track-value="capture"
            data-test="breachType"
          />
        )}
      />
    </FormCard>
  );
};

export default BreachType;
